import { Autocomplete, TextField } from '@mui/material';
import { Product } from '../../../types';

interface ProductFieldProps {
  disabled: boolean;
  options: Product[];
  value: Product | null;
  onChange: (event: React.SyntheticEvent<Element, Event>, value: Product | null) => void;
  displayFamilyName: boolean;
}

/** The Type of Service picker, naming each product's family when the account shows family names. */
export function ProductField({ disabled, options, value, onChange, displayFamilyName }: ProductFieldProps) {
  const label = (option: Product) => (displayFamilyName ? `${option.family} - ${option.name}` : option.name);
  return (
    <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
      <Autocomplete
        disabled={disabled}
        sx={{ width: '100%' }}
        size="small"
        options={options}
        value={value}
        onChange={onChange}
        getOptionLabel={label}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option.id}>
            {label(option)}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Type of Service*"
            inputProps={{
              ...params.inputProps,
              required: value === null
            }}
          />
        )}
      />
    </div>
  );
}
